module.exports = __webpack_public_path__ + "static/media/club-member.60007946.png";